// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".icon-block[data-v-3b222be7] {\n  font-size: 28px;\n  margin-right: 12px;\n  margin-top: 4px;\n}\n[data-v-3b222be7] .custom-icon .dot {\n  width: 30px !important;\n  height: 30px !important;\n}\n[data-v-3b222be7] .custom-icon .dot .title-icon {\n  margin-top: 2px;\n  font-size: 15px;\n}", ""]);
// Exports
module.exports = exports;
